import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';

export const SortFilter = ({ sortButtons, sortText, toggle, filterFields, filterBoxClassName, hideSortText, testId }) => {
    return (
        <div data-testid={testId}>
            <div className="row mb10">
                <div className="col-md-12 flex flex-center">
                    {sortButtons && typeof sortButtons === 'function' ? (
                        <div className="flex-grow">
                            <div className="flex flex-center">
                                {!hideSortText && (
                                    <div className="text-sm mr10">
                                        <strong>{sortText || SystemText('General/SortFilter/SortText')}:</strong>
                                    </div>
                                )}
                                <div className="flex-grow">{sortButtons()}</div>
                            </div>
                        </div>
                    ) : (
                        <div className="flex-grow" />
                    )}

                    {toggle && typeof toggle === 'function' && (
                        <div className={`text-right text-sm toggle hidden-xs hidden-sm`}>{toggle()}</div>
                    )}
                </div>
            </div>
            {filterFields && typeof filterFields === 'function' && (
                <div className="row">
                    <div className="col-md-12">
                        <div className={filterBoxClassName || 'filter-raw'}>{filterFields()}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SortFilter;
